import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function CouponsPage() {
  const { t } = useTranslation();

  const coupons = [
    { code: "ACB2026", offer: "New User Discount", eligibility: "First-time users", status: "Check website", lastChecked: "2026-08-25" },
    { code: "SHIPFREE", offer: "Shipping Credit", eligibility: "Orders over $100", status: "Check website", lastChecked: "2026-08-25" },
    { code: "WELCOME", offer: "Account Credit", eligibility: "New registrations", status: "Check website", lastChecked: "2026-08-25" },
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="pt-28 md:pt-32 pb-16">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
                {t("coupon")} & {t("discountCode")}
              </h1>
              <p className="text-foreground-600 max-w-2xl mx-auto">
                Find the latest coupons, discount codes, and promotional offers for AllChinaBuy. Note: All codes should be verified on the official website before use.
              </p>
            </div>

            <div className="space-y-8">
              <div className="p-6 md:p-8 rounded-2xl bg-accent-50/50 border border-accent-200/50">
                <div className="flex items-start gap-3">
                  <i className="ri-information-line text-accent-600 text-xl mt-0.5 shrink-0" />
                  <div>
                    <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">Important Notice</h3>
                    <p className="text-sm text-foreground-700 leading-relaxed">
                      This website does not provide verified coupon codes. All promotional codes listed here are for reference only and must be verified directly on the AllChinaBuy website or official channels. We do not guarantee the validity or availability of any coupon codes.
                    </p>
                  </div>
                </div>
              </div>

              <div className="overflow-x-auto rounded-2xl border border-background-200/70 bg-background-100">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-background-200/70">
                      <th className="px-4 py-3 text-left font-semibold text-foreground-800">Code</th>
                      <th className="px-4 py-3 text-left font-semibold text-foreground-800">Offer</th>
                      <th className="px-4 py-3 text-left font-semibold text-foreground-800">Eligibility</th>
                      <th className="px-4 py-3 text-left font-semibold text-foreground-800">Status</th>
                      <th className="px-4 py-3 text-left font-semibold text-foreground-800">Last Checked</th>
                    </tr>
                  </thead>
                  <tbody>
                    {coupons.map((c) => (
                      <tr key={c.code} className="border-b border-background-200/50 last:border-0">
                        <td className="px-4 py-3 font-mono font-semibold text-primary-600">{c.code}</td>
                        <td className="px-4 py-3 text-foreground-700">{c.offer}</td>
                        <td className="px-4 py-3 text-foreground-600">{c.eligibility}</td>
                        <td className="px-4 py-3">
                          <span className="inline-flex items-center px-2 py-1 rounded-md bg-secondary-100 text-secondary-800 text-xs font-medium">
                            {c.status}
                          </span>
                        </td>
                        <td className="px-4 py-3 text-foreground-500 text-xs">{c.lastChecked}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">Where to Find Valid Coupons</h2>
                <ul className="space-y-3 text-sm text-foreground-700">
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-check-line text-primary-600 text-xs" />
                    </span>
                    <span>Visit the official AllChinaBuy website and check their promotions page</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-check-line text-primary-600 text-xs" />
                    </span>
                    <span>Sign up for their newsletter to receive promotional codes</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-check-line text-primary-600 text-xs" />
                    </span>
                    <span>Follow their official social media channels for flash sales</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-check-line text-primary-600 text-xs" />
                    </span>
                    <span>Check community forums and Discord for user-shared codes</span>
                  </li>
                </ul>
              </div>

              <div className="p-6 md:p-8 rounded-2xl bg-primary-500/10 border border-primary-200/50 text-center">
                <h3 className="font-heading text-xl font-bold text-foreground-900 mb-2">Visit the Official Website</h3>
                <p className="text-foreground-600 mb-6 text-sm">Check for current promotions and valid coupon codes.</p>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-block px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition-colors"
                >
                  {t("ctaVisitMain")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}